var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"d-none d-md-block video-container"},[_c('iframe',{attrs:{"src":_vm.source,"title":"YouTube video player","frameborder":"0","allow":"accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture","allowfullscreen":""}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }